import React from 'react';

import { ToggleSection } from '../../ToggleSection';
import ChangeLogTablesList from '../ChangeLogTablesList';
import ChangeLogTitle from '../ChangeLogTitle';
import type { TargetingChanges, Toggles } from '../hooks/types';
import type { DefaultAudit } from '../types';

interface Props {
  audits: DefaultAudit;
  creativeAudits: DefaultAudit;
  toggles: Toggles[];
  toggleAt: (index: number, value: boolean | boolean[]) => void;
  originalIndex: number;
  dateFormat: string;
  modifiedBy: string | null;
  creativeModifiedBy: string | null;
  creativeDateFormat: string;
  targetingChanges?: TargetingChanges;
}

const ChangeLogListEntry = ({
  audits,
  creativeAudits,
  toggles,
  toggleAt,
  originalIndex,
  dateFormat,
  creativeDateFormat,
  modifiedBy,
  creativeModifiedBy,
  targetingChanges,
}: Props): JSX.Element => {
  const isExpanded = Array.isArray(toggles[originalIndex])
    ? (toggles[originalIndex] as boolean[])[0]
    : (toggles[originalIndex] as boolean);

  const title = (
    <ChangeLogTitle
      id={`toggle-title-${originalIndex}`}
      changesPlural={audits.changesPlural}
      formattedDate={dateFormat}
      modifiedBy={modifiedBy}
    />
  );

  return (
    <ToggleSection
      title={title}
      isExpanded={isExpanded}
      handleToggle={(): void => {
        toggleAt(originalIndex, toggles[originalIndex]);
      }}
      key={`toggle-${originalIndex}`}
    >
      <ChangeLogTablesList
        tablesProps={audits.tablesProps}
        creativeTablesProps={creativeAudits}
        targetingChanges={targetingChanges}
        creativeDateFormat={creativeDateFormat}
        creativeModifiedBy={creativeModifiedBy || ''}
        toggles={toggles}
        index={originalIndex}
        toggleAt={toggleAt}
      />
    </ToggleSection>
  );
};

export default ChangeLogListEntry;
